import PropTypes from "prop-types";
import React from "react";

import cgiGRP2Context from "./contexts/cgiGRP2Context";

RootElementWrapper.propTypes = {
  pluginOptions: PropTypes.shape({ apiPath: PropTypes.string }).isRequired,
  children: PropTypes.node,
};

export default function RootElementWrapper({
  children,
  pluginOptions: { apiPath = "/grp2" },
}) {
  const { Provider } = cgiGRP2Context;
  return (
    <Provider
      value={{
        apiPath,
      }}
    >
      {children}
    </Provider>
  );
}
